import { lazy, Suspense } from 'react'
import { Loader2 } from 'lucide-react'
import { GameAppearanceProvider } from '@/contexts/GameAppearanceContext'

// Lazy load do GameSession para melhor performance
const GameSessionClassic = lazy(() => import('./GameSession').then(m => ({ default: m.GameSession })))

// Loading fallback
function LayoutLoader() {
  return (
    <div className="h-screen w-full flex items-center justify-center bg-game-primary dark:bg-zinc-950">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-violet-500" />
        <span className="text-game-muted dark:text-zinc-400 text-sm">Carregando sessão...</span>
      </div>
    </div>
  )
}

/**
 * Wrapper que renderiza o GameSession com lazy loading.
 * O GameAppearanceProvider escopa o claro/escuro da mesa a esta rota:
 * aplica .dark + data-game-appearance no body enquanto montado e limpa ao
 * sair — o tema da conta (data-theme no <html>) nunca e tocado.
 */
export function GameSessionWrapper() {
  return (
    <GameAppearanceProvider>
      <Suspense fallback={<LayoutLoader />}>
        <GameSessionClassic />
      </Suspense>
    </GameAppearanceProvider>
  )
}

export default GameSessionWrapper
